// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6228b0bc","455":"60afcd11","977":"7ec46bb9"}[chunkId] + ".chunk.js";
};